module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_1000000.4e8cfa00.png";